import { Controller } from "@hotwired/stimulus";

// Stimulus controller for managing search form state and interactions
export default class extends Controller {
  static targets = ["form"];

  connect() {
    console.log("Search form controller connected");
  }

  // Handle form submission with loading state
  submit(event) {
    // Add a loading state to the form if needed
    this.element.classList.add("opacity-75");

    // The form will submit normally, but we can add loading indicators here
    setTimeout(() => {
      this.element.classList.remove("opacity-75");
    }, 500);
  }

  // Clear all search parameters
  clear() {
    const inputs = this.element.querySelectorAll("input, select");
    inputs.forEach((input) => {
      if (
        input.type === "search" ||
        input.type === "text" ||
        input.type === "date"
      ) {
        input.value = "";
      } else if (input.tagName === "SELECT") {
        input.selectedIndex = 0;
      }
    });

    // Submit the cleared form
    this.element.requestSubmit();
  }
}
